export enum UserRole {
  Patient = 'patient',
  Agent = 'agent',
  Test = 'test',
}

// API Models

export interface ApiUpdatePasswordRequest {
  oktaId: string;
  currentPassword: string;
  newPassword: string;
}

export interface ApiLoginPatientResponse {
  id: number;
  sessionId?: number; // TODO Mark as required when test patient users are supported
}

export interface ApiLoginPatientRequest {
  ipAddress: string;
  patientId: number;
}

export interface AuthenticatedUser {
  email: string;
  oktaId: string;
  role: UserRole;
}

export interface ApiSearchPatientResponseItem {
  patientId: number;
  createdAt: string;
  lastSessionAt?: string;
  isLegacyUser: boolean;
}

export interface ApiSearchUsersResponse {
  oktaId: string;
  patients: ApiSearchPatientResponseItem[];
}

// Front End Models

export interface User {
  id: number;
  sessionId?: number;
  selectedPatientId?: number;
}

export interface UpdatePasswordForm {
  currentPassword: string;
  newPassword: string;
  repeatPassword: string;
}

export interface SearchUsersFormValue {
  patientId: number;
}

export interface AgentLoadedPatient {
  oktaId: string;
  patientId: string;
  createdAt: string;
  lastSessionAt: string;
  isLegacyUser: boolean;
  linkedPatients: string;
}

export interface SearchUsersResult extends ApiSearchUsersResponse {}

// Mappers

export const mapUser = (patientId: number, lpr: ApiLoginPatientResponse): User => {
  return {
    id: lpr.id,
    sessionId: lpr.sessionId,
    selectedPatientId: patientId,
  };
};

export const buildUpdatePasswordRequest = (
  oktaId: string,
  changePasswordForm: UpdatePasswordForm
): ApiUpdatePasswordRequest => {
  const { currentPassword, newPassword } = changePasswordForm;

  return {
    oktaId,
    currentPassword,
    newPassword,
  };
};

export const mapSearchUsers = (u: ApiSearchUsersResponse): SearchUsersResult => {
  return u;
};

export const mapSearchUsersToAgentLoadedPatient = (
  data: SearchUsersResult,
  selectedPatient: ApiSearchPatientResponseItem
): AgentLoadedPatient => {
  return {
    oktaId: data.oktaId,
    patientId: selectedPatient?.patientId.toString() || '',
    createdAt: selectedPatient?.createdAt || '',
    lastSessionAt: selectedPatient?.lastSessionAt || '',
    isLegacyUser: selectedPatient?.isLegacyUser!,
    linkedPatients:
      data.patients
        .filter((p) => p.patientId !== selectedPatient.patientId)
        .map((p) => p.patientId)
        .join(', ') || '',
  };
};
